import React from "react";
import TextField from "@material-ui/core/TextField";
import { Box } from "@material-ui/core";

export const colorBarRenderer = (
    value,
    name,
    fieldUpdateHandler,
    isError,
    mutable,
    editable,
) => {
    return (
        <Box width={"45%"}>
            {!!isError && <TextField error={!!isError} helperText={isError} />}
            <input
                type="color"
                value={value || ""}
                onChange={(e) => fieldUpdateHandler(name, e.target.value)}
                style={{
                    marginRight: "10px",
                    border: "none",
                    backgroundColor: "#FFFFFF",
                    outline: "none",
                    cursor: "pointer",
                }}
            />
        </Box>
    );
};
